import { render, staticRenderFns } from "./JalousieDown.vue?vue&type=template&id=479a4072&scoped=true&"
import script from "./JalousieDown.vue?vue&type=script&lang=js&"
export * from "./JalousieDown.vue?vue&type=script&lang=js&"
import style0 from "./JalousieDown.vue?vue&type=style&index=0&id=479a4072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a4072",
  null
  
)

export default component.exports